// sonDakika tarihleri "gg.aa.yyyy" formatında gelir (gün/ay tek haneli olabilir),
// link ise "yyyy-aa-gg" bekler
export const toIsoDate = (value) => {
  if (!value) return "";
  const parts = String(value).replace(/\//g, ".").split(".");
  if (parts.length != 3) return "";
  const [day, month, year] = parts;
  if (!day || !month || !year) return "";
  return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
};
